































































import { QInput, QCard, QCardSection, QTable, QTr, QTd, QTh, date, QMarkupTable, QBtn, QSelect } from 'quasar';
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { GetEnoteZrss, PostPrijavnica, PostGetToken, GetPrijavniceList, DownloadExcel } from '../../api';
import { IEnotaZrss, IPrijavnica } from '@/model';
import Checkmark from '../layout/checkmark.vue';
import AgModal from '../modal.vue';
import { getStorage, setStorage } from '../../utils/localstorage';


@Component({ components: { QInput, QCard, QCardSection, QTable, QTr, QTd, QTh, AgModal, QMarkupTable,QBtn, QSelect } })
export default class Prijavnica extends Vue {

    private inProgress = false;
    private filter = "";
    private prijavnice: IPrijavnica[] = [];
    private selected: IPrijavnica | null = null;
    private token: string | null = getStorage('token');    
    private user: string ="";
    private pass: string ="";
    private loginError: boolean = false;
    private obmocneEnote: IEnotaZrss[] = [];

    private pagination = {
        rowsPerPage: 30
    }; 
    private formatDate = (dateStr: string) => date.formatDate(dateStr, 'D. M. YYYY hh:mm');
    private columns = [
        { name: 'id', align: 'center', label: 'ŠT', field: 'id', sortable: true },
        { name: 'timestamp', align: 'left', label: 'Čas vnosa', field: 'timestamp', sortable: true, format: this.formatDate },
        { name: 'ustanovaNaziv', align: 'left', label: 'Ustanova', field: 'ustanovaNaziv', sortable: true },
        { name: 'ustanovaDavcna', align: 'left', label: 'Davcna', field: 'ustanovaDavcna', sortable: true },
        { name: 'storitevIzpeljavaLeto', align: 'left', label: 'Leto', field: 'storitevIzpeljavaLeto', sortable: true },
        { name: 'storitevIzpeljavaMesec', align: 'left', label: 'Mesec', field: 'storitevIzpeljavaMesec', sortable: true },
        { name: 'kontaktnaOsebaIme', align: 'left', label: 'Kontaktna oseba', field: 'kontaktnaOsebaIme', sortable: true },
        { name: 'kontaktnaOsebaTelefon', align: 'left', label: 'Kontaktna tel.', field: 'kontaktnaOsebaTelefon', sortable: true },
        { name: 'kontaktnaOsebaEmail', align: 'left', label: 'Kontaktna email.', field: 'kontaktnaOsebaEmail', sortable: true },
        { name: 'storitevVrsta', align: 'left', label: 'Storitev', field: 'storitevVrsta', sortable: true },
        { name: 'storitevImeSvetovalca', align: 'left', label: 'Svetovalec', field: 'storitevImeSvetovalca', sortable: true },
        { name: 'storitevNaslovTeme', align: 'left', label: 'Naslov', field: 'storitevNaslovTeme', sortable: false },
    ];
    private leta = [
        (new Date()).getFullYear(),
        (new Date()).getFullYear() + 1,
        (new Date()).getFullYear() + 2
    ];

    private get filteredPrijavnice() {
        if (this.filter) {
            return this.prijavnice.filter(p => p.ustanovaNaziv.includes(this.filter));
        }
        return this.prijavnice;
    }

    private get parsedToken () {
        if(!this.token) return {};
        const base64Url = this.token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(c=> {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    private rowClick(evt: any, prijavnica: any) {
        this.selected = prijavnica;
    }

    private prijava(){
        PostGetToken(this.user, this.pass).then(t=>{
            if(t.data){
                this.token = t.data;
                setStorage("token",t.data, 5*24*60*60);
            } else {
                this.loginError = true;
            }
        });
    }


    @Watch("token")
    private tokenChanged(token: string) {
        this.getData();
    }
    private getData() {
        if (this.token) {
            this.inProgress = true;
            GetPrijavniceList(this.token)
                .then(p => this.prijavnice = p.data)
                .finally(() => this.inProgress = false);
        }
    }
    private mounted() {
        GetEnoteZrss().then(a => this.obmocneEnote = a.data).finally(() => this.inProgress = false);
        this.getData();
      //  PostGetToken("sonja.zajc@zrss.si", "burek")
    }

    private download(){
        if(this.token)
        DownloadExcel(this.token).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'prijavnice.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });
    }


}
